<template>
  <section>
    <div class='mock'>
      <div class='main'>
        <img :src="loading">
        <div class="loading">加载中...</div>
      </div>
    </div>
  </section>
</template>

<script>
  import loading from '@/assets/loading.gif'
    export default {
        name: 'loading',
      data () {
        return {
          loading: loading
        }
      }
    }
</script>

<style scoped>
  section{
    width:100%
  }
  .mock{
  }
  .main{
    color:white;
    text-align:center;
  }
  .loading{
    font-size: 1.2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/loading.vue